// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import 'babel-polyfill'
import promise from 'es6-promise'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import iView from 'iview'
import iView from 'view-design'
//import Vuex from 'vuex'
import UUID from 'vue-uuid'
import mavonEditor from 'mavon-editor'
import axios from 'axios'
// import VueCookies from 'vue-cookies'
// import VTooltip from 'v-tooltip'
import VueRouter from 'vue-router'

// importing ViewUI on demand
import { locale, Page } from 'view-design';
//import lang from 'view-design/dist/locale/en-US';
import zh from 'view-design/dist/locale/zh-CN';


//float-ball



//require style,global css
import 'swiper/dist/css/swiper.css'
// import 'iview/dist/styles/iview.css'
import 'view-design/dist/styles/iview.css'
import 'mavon-editor/dist/css/index.css'
import './components/common/style/tooltips.scss'
import './assets/css/font.css'
import './assets/css/g.css'

//theme
// import './assets/css/index.less'

//import options
// import baseConfig from '../config.json'

//UI-Page-Status
import PageStatus from './components/common/util.js'
import store from './store/index.js'

//tool
import * as tools from './api/common/tools.js'
//api
import * as Api from './api/lib/api.request.js'

//console
import * as cs from './assets/js/gb'


//vue-introjs
import intro from 'intro.js' // 引入introjs库
import 'intro.js/introjs.css' // 引入introjscss样式
import 'intro.js/themes/introjs-modern.css' // 引入introjs主题 有多种主题可以选择 详见下方解释
//import 'intro.js/themes/introjs-dark.css'
Vue.prototype.$intro = intro // 加到prototype中，直接通过vue实例就能直接调用intro了



//test
const on = Vue.prototype.$on
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}


promise.polyfill()
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper);

Vue.use(iView, {
    transfer: true,
    size: 'default'
});

//全局配置消息显示时长
Vue.prototype.$Message.config({
//   top: 100,
  duration: 5
})


let option = { color: 'greenyellow', failedColor: '#f0ad4e', height: 3 }
Vue.prototype.$Loading.config(option)
Vue.use(PageStatus)
Vue.use(UUID)
Vue.use(mavonEditor)
//iview国际化
// configure language
locale(zh);
// import components
Vue.component('Page', Page);

//节流
Vue.prototype.$on = function (event, func) {
  let previous = 0
  let newFunc = func
  if (event === 'click') {
    newFunc = function () {
      const now = new Date().getTime()
      if (previous + 1000 <= now) {
        func.apply(this, arguments)
        previous = now
      }
    }
  }
  on.call(this, event, newFunc)
}




// Vue.use(VTooltip)
// Vue.use(VueCookies)
// VueCookies.config('1d')
// VueCookies.set('theme', 'default');

// Vue.use(Vuex) //在store页面已注册过
/* eslint-disable no-new */
Vue.prototype.$Tools = tools
Vue.prototype.$API = Api
//Vue.prototype.$Config=baseConfig
axios.get('./config.json').then((result) => {
    Vue.prototype.$baseConfig = result.data
    if (!Vue.prototype.$baseConfig.enableConsole) {
        cs.clog()
    }
    // new Vue({
    //     el: '#app',
    //     router,
    //     store,
    //     components: { App },
    //     template: '<App/>'
    // })

    console.log('start================>')

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount("#app")
    
    console.log(router.currentRoute)
    // console.log(router)
    // if(router.currentRoute.name==='userstore'){
    //     router.push('userstore')
    // }else{
    //     router.push('home')
    // }

    if(router.currentRoute.path==='/reg'){
        console.log('微信注册====>')
        let code=''
        let state=''
        let t=0
        if(router.currentRoute.query.code&&router.currentRoute.query.code!==''){
            code=router.currentRoute.query.code
        }
        if(router.currentRoute.query.state&&router.currentRoute.query.state!==''){
            state=router.currentRoute.query.state
        }
        //判断微信登录
        //&&store.state.user.userGuid!==''
        console.log(code,state)
        if(code!==''&&state!==''){
            store.state.user.wxcode=code
            store.state.user.wxstate=state
            store.state.user.iswxreg=true
            router.push('localsearch')
        }
    } else if(router.currentRoute.path==='/bindwx'){
        console.log('微信绑定====>')
        let code=''
        let state=''
        let t=0
        if(router.currentRoute.query.code&&router.currentRoute.query.code!==''){
            code=router.currentRoute.query.code
        }
        if(router.currentRoute.query.state&&router.currentRoute.query.state!==''){
            state=router.currentRoute.query.state
        }
        //判断微信登录
        //&&store.state.user.userGuid!==''
        console.log(code,state)
        if(code!==''&&state!==''){
            store.state.user.wxcode=code
            store.state.user.wxstate=state
            store.state.user.iswxbind=true
            router.push('localsearch')
        }
    } else if(router.currentRoute.name==='home'){
        console.log('判断微信登录====>')
        let code=''
        let state=''
        if(router.currentRoute.query.code&&router.currentRoute.query.code!==''){
            code=router.currentRoute.query.code
        }
        if(router.currentRoute.query.state&&router.currentRoute.query.state!==''){
            state=router.currentRoute.query.state
        }
        //判断微信登录
        //&&store.state.user.userGuid!==''
        console.log(code,state)
        if(code!==''&&state!==''){
            store.state.user.wxcode=code
            store.state.user.wxstate=state
            router.push('localsearch')
        }
    }else if(router.currentRoute.name==='matchfile'){
        console.log('matchfile===>')
        router.push('matchfile')
    }
    // else if(router.currentRoute.name==='taxchat'){
    //     console.log('taxchat===>')
    //     router.push('taxchat')
    // }
    else{
        router.push('home')
    }

   
    //router.push('search')
    // if(router.currentRoute.query.code&&router.currentRoute.query.code!==''){
    //      router.push('searchengine')
    // }else{
    //     router.push('main')
    // }
    

}).catch((error) => {
    console.log('get baseConfig error...' + error)
})

// new Vue({
//   el: '#app',
//   router,
//   store,
//   components: { App },
//   template: '<App/>'
// })